import React from "react";
import { Button, IconButton, TextField } from "@mui/material";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import Image from "mui-image";
import MALEACTIVE from "../../../assets/images/male-active.svg";
import MALEINACTIVE from "../../../assets/images/male-inactive.svg";
import FEMALEACTIVE from "../../../assets/images/female-active.svg";
import FEMALEINACTIVE from "../../../assets/images/female-inactive.svg";
import OTHERSACTIVE from "../../../assets/images/others-active.svg";
import OTHERSINACTIVE from "../../../assets/images/others-inactive.svg";
import { ReactComponent as LEFTICON } from "../../../assets/images/arrow-left-dark.svg";

export default function About({
  aboutObj = {},
  setAboutObj = () => {},
  step = 1,
  setStep = () => {},
  verifying = false,
  setVerifying = () => {},
  onBoardingUser = {},
}) {
  const [error, setError] = React.useState({
    firstName: false,
    lastName: false,
    dob: false,
  });

  const gender = [
    {
      name: "male",
      activeIcon: MALEACTIVE,
      inactiveIcon: MALEINACTIVE,
    },
    {
      name: "female",
      activeIcon: FEMALEACTIVE,
      inactiveIcon: FEMALEINACTIVE,
    },
    {
      name: "others",
      activeIcon: OTHERSACTIVE,
      inactiveIcon: OTHERSINACTIVE,
    },
  ];
  return (
    <>
      <div
        className="onboarding-step onboarding-step-3"
        style={{ padding: "1rem" }}
      >
        <p
          style={{
            margin: "20px 0 40px 0",
            fontSize: "26px",
            fontWeight: 700,
            textAlign: "center",
            color: "#CFCFCF",
          }}
        >
          About you
        </p>

        {/* form  */}
        <div>
          <div className="form-control">
            <p>FIRST NAME</p>
            <TextField
              className="form-input"
              variant="standard"
              fullWidth
              id="firstName"
              name="firstName"
              value={aboutObj?.firstName}
              onChange={(e) => {
                setAboutObj({ ...aboutObj, firstName: e.target.value });
                setError({
                  ...error,
                  firstName: e.target.value ? false : true,
                });
              }}
              error={error.firstName}
              helperText={error.firstName ? "Please enter your first name" : ""}
              placeholder="Type here...."
              InputProps={{
                disableUnderline: true,
              }}
            />
          </div>
          <div className="form-control">
            <p>LAST NAME</p>
            <TextField
              className="form-input"
              variant="standard"
              fullWidth
              id="lastName"
              name="lastName"
              value={aboutObj?.lastName}
              onChange={(e) => {
                setAboutObj({ ...aboutObj, lastName: e.target.value });
                setError({ ...error, lastName: e.target.value ? false : true });
              }}
              error={error.lastName}
              helperText={error.lastName ? "Please enter your last name" : ""}
              placeholder="Type here...."
              InputProps={{
                disableUnderline: true,
              }}
            />
          </div>
          <div className="form-control">
            <p>DATE OF BIRTH</p>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DesktopDatePicker
                inputFormat="MM/DD/YYYY"
                value={aboutObj?.dob}
                // onChange={(e) => setAboutObj({...aboutObj, dob: dayjs(e).format("YYYY-MM-DD")})}
                onChange={(e) => {
                  setAboutObj({
                    ...aboutObj,
                    dob: dayjs(e).format("MM/DD/YYYY"),
                  });
                  setError({ ...error, dob: e !== "" ? false : true });
                }}
                error={error.dob}
                helperText={error.dob ? "Please select your date of birth" : ""}
                disableFuture
                renderInput={(params) => (
                  <TextField
                    className="form-input"
                    style={{ color: "red" }}
                    {...params}
                    variant="standard"
                    inputProps={{
                      ...params.inputProps,
                      placeholder: "select date....",
                    }}
                    fullWidth
                    size="small"
                  />
                )}
                InputProps={{
                  disableUnderline: true,
                }}
              />
            </LocalizationProvider>
          </div>
          <div
            className="form-control"
            style={{ display: "flex", alignItems: "center" }}
          >
            <div style={{ width: "30%" }}>
              <p
                style={{
                  margin: "0 0 0 16px",
                  fontSize: 20,
                  fontWeight: 600,
                  color: "#bdbfc1",
                }}
              >
                Gender
              </p>
            </div>
            <div
              style={{
                width: "70%",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              {gender.map((g, i) => (
                <div key={i}>
                  <Image
                    src={
                      g?.name === aboutObj?.gender
                        ? g?.activeIcon
                        : g?.inactiveIcon
                    }
                    width={54}
                    height={54}
                    onClick={() =>
                      setAboutObj({ ...aboutObj, gender: g?.name })
                    }
                  />
                  <p
                    style={{
                      margin: "4px 0 0 14px",
                      height: 20,
                      fontSize: 14,
                      fontWeight: 600,
                      color: "#bdbfc1",

                      textAlign: "center",
                      textTransform: "capitalize",
                    }}
                  >
                    {g?.name === aboutObj?.gender ? g?.name : " "}
                  </p>
                </div>
              ))}
            </div>
          </div>
          <div
            className="form-control"
            style={{ display: "flex", alignItems: "center" }}
          >
            <div style={{ width: "50%" }}>
              <p
                style={{
                  margin: "0 0 0 16px",
                  fontSize: 20,
                  fontWeight: 600,
                  color: "#bdbfc1",
                }}
              >
                Weight{" "}
                <span
                  style={{ fontSize: 16, fontWeight: 400, color: "#6F7379" }}
                >
                  (In kg)
                </span>
              </p>
            </div>
            <div
              style={{
                width: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              <div className="scroll-input-div">
                <IconButton
                  aria-label="decrease"
                  onClick={() =>
                    setAboutObj({ ...aboutObj, weight: aboutObj?.weight - 1 })
                  }
                >
                  <LEFTICON />
                </IconButton>
                <TextField
                  className="form-input"
                  variant="standard"
                  fullWidth
                  id="weight"
                  name="weight"
                  value={aboutObj?.weight}
                  onChange={(e) =>
                    setAboutObj({ ...aboutObj, weight: e.target.value })
                  }
                  placeholder="Type here...."
                  InputProps={{
                    disableUnderline: true,
                  }}
                  inputProps={{
                    min: 0,
                    style: {
                      textAlign: "center",
                      fontSize: 26,
                      fontWeight: 600,
                    },
                  }}
                />
                <IconButton
                  aria-label="increase"
                  style={{ transform: "rotate(180deg)" }}
                  onClick={() =>
                    setAboutObj({ ...aboutObj, weight: aboutObj?.weight + 1 })
                  }
                >
                  <LEFTICON />
                </IconButton>
              </div>
            </div>
          </div>
          <div
            className="form-control"
            style={{ display: "flex", alignItems: "center" }}
          >
            <div style={{ width: "50%" }}>
              <p
                style={{
                  margin: "0 0 0 16px",
                  fontSize: 20,
                  fontWeight: 600,
                  color: "#bdbfc1",
                }}
              >
                Height{" "}
                <span
                  style={{ fontSize: 16, fontWeight: 400, color: "#6F7379" }}
                >
                  (In cm)
                </span>
              </p>
            </div>
            <div
              style={{
                width: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              <div className="scroll-input-div scroll-input-div-2">
                <IconButton
                  aria-label="increase"
                  onClick={() =>
                    setAboutObj({ ...aboutObj, height: aboutObj?.height + 1 })
                  }
                  style={{ transform: "rotate(90deg)" }}
                >
                  <LEFTICON />
                </IconButton>
                <TextField
                  className="form-input"
                  variant="standard"
                  fullWidth
                  id="height"
                  name="height"
                  value={aboutObj?.height}
                  onChange={(e) =>
                    setAboutObj({ ...aboutObj, height: e.target.value })
                  }
                  placeholder="Type here...."
                  InputProps={{
                    disableUnderline: true,
                  }}
                  inputProps={{
                    min: 0,
                    style: {
                      textAlign: "center",
                      fontSize: 26,
                      fontWeight: 600,
                    },
                  }}
                />
                <IconButton
                  aria-label="decrease"
                  style={{ transform: "rotate(270deg)" }}
                  onClick={() =>
                    setAboutObj({ ...aboutObj, height: aboutObj?.height - 1 })
                  }
                >
                  <LEFTICON />
                </IconButton>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="request-footer-btn">
        <Button
          onClick={() => setStep(step + 1)}
          fullWidth
          variant="contained"
          size="large"
          style={{
            padding: "16px 0",
            fontSize: "1em",

            background:
              verifying ||
              error?.firstName ||
              error?.lastName ||
              error?.dob ||
              aboutObj?.firstName === "" ||
              aboutObj?.lastName === "" ||
              aboutObj?.dob === ""
                ? "#383838"
                : "linear-gradient(91.75deg, #FFFFFF 0.11%, #C4C4C4 100.1%)",
            color:
              verifying ||
              error?.firstName ||
              error?.lastName ||
              error?.dob ||
              aboutObj?.firstName === "" ||
              aboutObj?.lastName === "" ||
              aboutObj?.dob === ""
                ? "#232323"
                : "#FF4A01",
          }}
          disabled={
            verifying ||
            error?.firstName ||
            error?.lastName ||
            error?.dob ||
            aboutObj?.firstName === "" ||
            aboutObj?.lastName === "" ||
            aboutObj?.dob === ""
          }
        >
          {verifying ? "Submitting..." : "Continue"}
        </Button>
      </div>
    </>
  );
}
